import StoredLayout from '../../layouts/StoredLayout'
import PieChartWidgets from './PieChartWidgets'
export default StoredLayout(PieChartWidgets)
